import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "../../../customBuilds/ckeditor5-custom-classic-mention-build";
import "./PostComment.scss";
import UserInfo from "@utils/UserInfo";

const PostComment = (props) => {
  const { t, setDescriptionData, setMentionList, descriptionData } = props;

  const countryId = UserInfo.countryId();

  async function getFeeds(search) {
    const response = await axios.get(
      `/general/search?search=${search}&limit=50&orderBy=asc&orderColumn=name&objectTypes=["admin","group","mention"]&countries=[${countryId}]`
    );
    return response.data;
  }

  const customItemRenderer = (item) => {
    const itemElement = document.createElement("span");

    itemElement.classList.add("custom-item");
    itemElement.id = `mention-list-item-id-${item.id}`;
    itemElement.textContent = `${item.name} `;

    const usernameElement = document.createElement("span");

    usernameElement.classList.add("custom-item-username");
    if (item.type === "group") usernameElement.textContent = `(${item.type})`;

    itemElement.appendChild(usernameElement);

    return itemElement;
  };

  const MentionCustomization = (editor) => {
    // The upcast converter will convert view <a class="mention" href="" data-user-id="">
    // elements to the model 'mention' text attribute.

    editor.conversion.for("upcast").elementToAttribute({
      view: {
        name: "a",
        key: "data-mention",
        classes: "mention",
        attributes: {
          href: true,
          "data-user-id": true,
        },
      },
      model: {
        key: "mention",
        value: (viewItem) => {
          // The mention feature expects that the mention attribute value
          // in the model is a plain object with a set of additional attributes.
          // In order to create a proper object use the toMentionAttribute() helper method:
          const mentionAttribute = editor.plugins
            .get("Mention")
            .toMentionAttribute(viewItem, {
              // Add any other properties that you need.
              link: viewItem.getAttribute("href"),
              userId: viewItem.getAttribute("data-user-id"),
            });

          return mentionAttribute;
        },
      },
      converterPriority: "high",
    });

    editor.conversion.for("downcast").attributeToElement({
      model: "mention",
      view: (modelAttributeValue, { writer }) => {
        // Do not convert empty attributes (lack of value means no mention).
        if (!modelAttributeValue) {
          return;
        }

        return writer.createAttributeElement(
          "a",
          {
            class: "mention",
            "data-mention": modelAttributeValue.id,
            "data-user-id": modelAttributeValue.userId,
            href: modelAttributeValue.link,
          },
          {
            // Make mention attribute to be wrapped by other attribute elements.
            priority: 20,
            // Prevent merging mentions together.
            id: modelAttributeValue.uid,
          }
        );
      },
      converterPriority: "high",
    });
  };

  return (
    <div className="add-comment">
      <CKEditor
        editor={Editor}
        data={descriptionData}
        config={{
          extraPlugins: ["Mention", MentionCustomization, "FontFamily"],
          mention: {
            feeds: [
              {
                marker: "@",
                feed: getFeeds,
                minimumCharacters: 1,
                itemRenderer: customItemRenderer,
              },
            ],
          },
          fontSize: {
            options: [
              "tiny",
              "small",
              "default",
              "big",
              "huge",
              8,
              9,
              10,
              11,
              12,
              14,
              16,
              18,
              20,
              22,
              24,
              26,
              28,
              36,
              48,
            ],
          },
          toolbar: [
            "heading",
            "|",
            "fontFamily",
            "fontSize",
            "FontColor",
            "FontBackgroundColor",
            "|",
            "bold",
            "italic",
            "link",
            // "bulletedList",
            // "numberedList",
            // "blockQuote",
            // "ckfinder",
            "|",
            // "imageTextAlternative",
            // "imageUpload",
            // "imageStyle:full",
            // "imageStyle:side",
            // "|",
            "mediaEmbed",
            "insertTable",
            // "tableColumn",
            // "tableRow",
            // "mergeTableCells",
            "|",
            "undo",
            "redo",
          ],
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          setDescriptionData(data);
          const range = editor.model.createRangeIn(
            editor.model.document.getRoot()
          );

          const mentions = [];

          for (const treeWalker of range.getWalker({
            ignoreElementEnd: true,
          })) {
            if (treeWalker.type === "text") {
              const node = treeWalker.item.textNode;

              if (node.hasAttribute("mention")) {
                const mention = node.getAttribute("mention");
                if (mention) {
                  mentions.push(mention);
                  setMentionList(mentions);
                }
              }
            }
          }
        }}
      />
    </div>
  );
};

export default withTranslation()(PostComment);
